export default __webpack_public_path__ + "static/media/Pin_Icon.ff2069d9.svg";